import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-m',
    templateUrl: './m.component.html',
    styleUrls: ['./m.component.scss'],
    standalone: false
})
export class MComponent {
    tooltip_position = 'above';
    @Input() form: UntypedFormGroup;
}
